import {servInstance} from "lib/helpers/common";

export const configData = {
    _config: {agent: {companyID: null}},

    get config () {
        return this._config;
    },
    set config (config) {
        return this._config = config;
    },

    get groupIDs () {
        return this._config.groupIDs;
    },

    get serverID () {
        return servInstance + this._config.agent.companyID;
    }
}